export default __webpack_public_path__ + "static/desktop-7272df050e69134d13fe5ffd6ee2b286.svg";